import { TranslateArg, TranslateArgFunc, TranslateResult } from '../types/translate';
import React from 'react';

// Corrected and strictly typed
export function replaceWithArgs(
  str: string,
  ...args: TranslateArg<React.ReactNode>[]
): TranslateResult<React.ReactNode> {
  let complex = false;
  const chunks: (string | React.ReactNode)[] = [];

  // TODO(niklasb) this regex prevents stuff like {0:Foo {platform.name} bar}
  const r = /\{(\d+)(?::([^}]*))?\}/g;

  const addStringChunk = (start: number, end: number) => {
    if (end > start) {
      chunks.push(str.slice(start, end));
    }
  };

  let start = 0;
  let m: RegExpExecArray | null;
  let key = 0;

  while ((m = r.exec(str))) {
    addStringChunk(start, m.index);
    const [all, num, param] = m;
    const i = parseInt(num, 10);

    if (i < 0 || i >= args.length) {
      throw new Error(`Invalid argument ID in translation string: ${i} in ${str}`);
    }

    const arg = args[i];
    const isFuncArg = typeof arg === 'function';

    if (param !== undefined && !isFuncArg) {
      throw new Error(`Parameter for translation argument is ignored: ${i} (param: ${param})`);
    }

    const argFunc: TranslateArgFunc<React.ReactNode> = isFuncArg
      ? (arg as TranslateArgFunc<React.ReactNode>)
      : () => arg as string | React.ReactNode;

    const chunk = argFunc(param, key++);

    if (typeof chunk !== 'string') {
      complex = true;
    }

    chunks.push(chunk);
    start = m.index + all.length;
  }

  addStringChunk(start, str.length);

  return complex ? chunks : chunks.join('');
}

export const replaceWithStringArgs = (str: string, ...args: TranslateArg<string>[]): string => {
  const res = replaceWithArgs(str, ...args);

  if (typeof res !== 'string') {
    throw new Error('Expected a simple string, but got complex output.');
  }
  return res;
};

export default replaceWithArgs;
